import { Dispatch } from 'redux';
import * as ActionTypes from 'src/constants/ActionTypes';
import { IDoctorSellerSetting } from 'src/entity/DoctorEntity';
import { IDrugStoreInfo } from 'src/entity/DrugStoreEntity';
import { IStateDrugStore, IStoreState } from 'src/entity/StateEntity';
import DrugStoreService from 'src/services/DrugStoreService';

export function reloadDrugStores(): IStateDrugStore {
  return {
    reload: true,
    isFetching: false,
    type: ActionTypes.DRUGSTORE_STATUS_RELOAD,
    drugStores: [],
  };
}

export function requestDrugStores(): IStateDrugStore {
  return {
    reload: false,
    isFetching: true,
    type: ActionTypes.DRUGSTORE_STATUS_REQUEST,
    drugStores: [],
  };
}

export function receiveDrugStores(drugStores: IDrugStoreInfo[], isSuccess: boolean): IStateDrugStore {
  return {
    reload: !isSuccess,
    isFetching: false,
    type: isSuccess ? ActionTypes.DRUGSTORE_STATUS_SUCCESS : ActionTypes.DRUGSTORE_STATUS_FAILURE,
    drugStores,
  };
}

export function fetchDrugStores(): any {
  return async (dispatch: Dispatch<IStateDrugStore>): Promise<IStateDrugStore> => {
    dispatch(requestDrugStores());
    return DrugStoreService.getAgentDrugStore()
      .then((res: IDrugStoreInfo[]) => dispatch(receiveDrugStores(res, true)))
      .catch((error) => dispatch(receiveDrugStores([], false)));
  };
}

export function shouldFetchDrugStores(storeState: IStoreState): boolean {
  const { drugStoreState } = storeState;
  return (drugStoreState.reload || drugStoreState.drugStores.length === 0) && !drugStoreState.isFetching;
}

export function fetchDrugStoresIfNeeded(): any {
  return (dispatch: Dispatch<IStateDrugStore>, getState: any) => {
    if (shouldFetchDrugStores(getState())) {
      return dispatch(fetchDrugStores());
    } else {
      const { drugStoreState } = getState() as IStoreState;
      // dispatch(receiveDrugStores(drugStoreState.drugStores, true));
      DrugStoreService.initAgentDrugStoreMap(drugStoreState.drugStores);
    }
  };
}

/**
 * 验证选中配药中心服务范围是否包含医生职业地址
 *
 * @private
 * @param {number[]} regions 配药中心服务范围
 * @param {number[]} locationChain 医生执业地址省市区
 * @returns
 * @memberof PharmacySelect
 */
export function validateRegionError(regions: number[], locationChain: number[]) {
  let isValid = true;
  if (regions.length > 0) {
    // 服务范围不为空数组，才检测范围
    for (let i = 0, len = locationChain.length; i < len; i++) {
      const locationId = locationChain[i];
      const isExisted = regions.findIndex((region) => region === locationId) !== -1;
      if (isExisted) {
        isValid = true;
        break;
      } else {
        isValid = false;
      }
    }
  }
  return !isValid;
}

/**
 * 根据UUID填充配药中心的名称
 *
 * @export
 * @param drugStores
 * @param UUIDList
 * @returns
 */
export function fixDrugStoreSettingData(drugStores: IDrugStoreInfo[], UUIDList: string[]): IDoctorSellerSetting[] {
  const result: IDoctorSellerSetting[] = [];
  for (const uuid of UUIDList) {
    const obj = drugStores.find((t) => t.seller_user === uuid);
    if (!!obj) {
      result.push({
        seller_user: uuid,
        name: obj.name,
      });
    }
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/redux/actions/drugStoreCreator.ts